<script setup lang="ts">
import { computed, useAttrs } from 'vue'

interface Props {
  /** Display an info icon with a tooltip with the given text */
  info?: string | null
  /** Whether the field is required */
  required?: boolean
}

const { info = null } = defineProps<Props>()

defineOptions({
  name: 'BaseLabel'
})

const attrs = useAttrs()

/**
 * Fetch `for` attribute from passed attributes
 */
const labelFor = computed(() => (attrs.for as string | undefined) ?? null)
</script>

<template>
  <div class="base-label flex flex-row items-start fill-current">
    <label
      :for="labelFor"
      class="input-label flex items-start fill-current select-none"
    >
      <slot></slot>
      <span v-if="required" class="input-required ml-1">*</span>
    </label>
    <VIcon
      v-if="info"
      v-tooltip="info"
      icon="$information-outline"
      class="mb-1 ml-2 inline-block self-center align-middle text-primary focus:outline-hidden"
      size="small"
    />
  </div>
</template>
